import { YouSetDomains as CommonLinks, YouSetWebpageLinks } from '~frontend-common/routes';

export const Links = {
  ...CommonLinks,
  pages: { ...YouSetWebpageLinks },
};
